export default __webpack_public_path__ + "de6d87d45a330f850c1e1a8027ba9df0.svg";